import React from 'react';
import ReactDOM from 'react-dom/client';
import IndexPage from './pages/index';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <IndexPage />
  </React.StrictMode>,
);
